import { Component, Input, AfterViewInit, Inject } from '@angular/core'
import { UnespCoreAuthService } from '../../services/unesp-core-auth/unesp-core-auth.service'
import { UnespCoreUsuario } from '../../interfaces/unesp-core-usuario'
import { UnespCoreMenuNavigationService } from '../../services/unesp-core-menu-navigation/unesp-core-menu-navigation.service'
import { UnespCoreUserService } from '../../services/unesp-core-user/unesp-core-user.service'
import { Observable } from 'rxjs'
import { EnvironmentName, UnespCoreEnvironment } from '../../interfaces'
import { ThemePalette } from '@angular/material/core'

/**
 * @description
 *
 * Este componente representa o cabeçalho da aplicação, disponibilizando o menu, login e logout.
 *
 */
@Component({
  selector: 'unicamp-core-header',
  templateUrl: './unicamp-core-header.component.html',
  styleUrls: ['./unicamp-core-header.component.css'],
})
export class UnicampCoreHeaderComponent implements AfterViewInit {
  /**
   * @description
   *
   * Nome completo da aplicação a ser exibido em telas maiores.
   *
   */
  @Input() fullTitle!: string

  /**
   * @description
   *
   * Nome abreviado da aplicação a ser exibido em telas menores.
   *
   */
  @Input() shortTitle!: string

  /**
   * @description
   *
   * Exibe username no cabeçalho ao lado do botão logout.
   *
   */
  @Input() usernameOnHeader: boolean = true

  /**
   * @description
   *
   * Caminho do logotipo que será exibido
   *
   */
  @Input() logo: string = 'assets/img/unicamp-logo.png'

  @Input() logoDetic: string = 'assets/img/detic-logo.png'

  /**
   * @description
   *
   * Caminho do logotipo customizado que será exibido
   *
   */
  @Input() logoCustom: string | undefined

  /**
   * @description
   *
   * Define se o botão do menu irá aparecer a todo momento.
   * Mesmo sem um usuário logado.
   *
   */
  @Input() publicMenu: boolean = true

  /**
   * @description
   *
   * Define se adicionará e exibirá as funcionalidades do componente
   * de countdown timer no cabeçalho.
   */
  @Input() showCountdownTimer: boolean = true

  /**
   * @description
   *
   * Define se exibirá o botão de login no header
   */
  @Input() loginOnHeader: boolean = false

  /**
   * @description
   *
   * Define se exibirá o botão de logout no header
   */
  @Input() logoutOnHeader: boolean = true

  fullTitleEnvPreffix = ''

  shortTitleEnvPreffix = ''

  headerColor = ''

  constructor(
    public unespCoreMenuNavigationService: UnespCoreMenuNavigationService,
    private unespCoreAuthService: UnespCoreAuthService,
    private unespCoreUserService: UnespCoreUserService,
    @Inject('environment') protected environment: UnespCoreEnvironment
  ) {
    this.defineHeaderColor(environment.envName)
    this.defineTitlePreffix(environment.envName)
  }

  ngAfterViewInit(): void {
    this.unespCoreMenuNavigationService.publicMenu = this.publicMenu
    this.unespCoreMenuNavigationService.refreshMenu()
  }

  logout(): void {
    this.unespCoreAuthService.logout('Usuário desconectado com sucesso')
    this.unespCoreMenuNavigationService.appDrawer?.close()
  }

  get user$(): Observable<UnespCoreUsuario | null> {
    return this.unespCoreUserService.user$
  }

  defineTitlePreffix(envName: EnvironmentName) {
    switch (envName) {
      case 'development':
        this.fullTitleEnvPreffix = 'DESENVOLVIMENTO / TESTES - '
        this.shortTitleEnvPreffix = 'DES - '
        break
      case 'homolog':
        this.fullTitleEnvPreffix = 'HOMOLOGAÇÃO / TESTES - '
        this.shortTitleEnvPreffix = 'HOM - '
        break
      case 'homolog-vm':
        this.fullTitleEnvPreffix = 'HOMOLOGAÇÃO VM / TESTES - '
        this.shortTitleEnvPreffix = 'HOM VM - '
        break

      default:
        this.fullTitleEnvPreffix = ''
        this.shortTitleEnvPreffix = ''
        break
    }
  }

  defineHeaderColor(envName: EnvironmentName) {
    switch (envName) {
      case 'development':
        this.headerColor = 'des'
        break
      case 'homolog':
        this.headerColor = 'homolog'
        break
      case 'homolog-vm':
        this.headerColor = 'homolog-vm'
        break

      default:
        this.headerColor = ''
        break
    }
  }
}
